"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobile_detect_1 = __importDefault(require("mobile-detect"));

var downloadjs_1 = __importDefault(require("downloadjs"));

exports.isFirefox = function () {
  return typeof InstallTrigger !== 'undefined';
};

exports.isIE = function () {
  return !!document.documentMode;
};

var deviceDetector = new mobile_detect_1.default(window.navigator.userAgent);

exports.retrieveWidth = function () {
  var width = 0;

  if (document.body && document.body.offsetWidth) {
    width = document.body.offsetWidth;
  }

  if (document.compatMode === 'CSS1Compat' && document.documentElement && document.documentElement.offsetWidth) {
    width = document.documentElement.offsetWidth;
  }

  return width;
};

exports.getURLParams = function (search) {
  var urlParams = {};
  var location = new URLSearchParams(search);

  for (var _len = arguments.length, paramsToRetrieve = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    paramsToRetrieve[_key - 1] = arguments[_key];
  }

  paramsToRetrieve.forEach(function (paramName) {
    var value = location.get(paramName);
    urlParams[paramName] = value;
  });
  return urlParams;
};

exports.isMobile = function (mobileBreakpoint) {
  return !!deviceDetector.phone() || exports.retrieveWidth() <= mobileBreakpoint;
};

exports.isTablet = function (mobileBreakpoint, tabletBreakpoint) {
  return !!deviceDetector.tablet() || exports.retrieveWidth() <= tabletBreakpoint && exports.retrieveWidth() > mobileBreakpoint;
};

exports.isDesktop = function (tabletBreakpoint) {
  return exports.retrieveWidth() > tabletBreakpoint;
};

exports.isDesktopHD = function (tabletBreakpoint, hDBreakpoint) {
  return exports.isDesktop(tabletBreakpoint) && exports.retrieveWidth() <= hDBreakpoint;
};

exports.isBigScreen = function (hDBreakpoint) {
  return exports.retrieveWidth() > hDBreakpoint;
};

exports.isLandscape = function () {
  return window.matchMedia('(orientation: landscape)').matches;
};

exports.isPortrait = function () {
  return window.matchMedia('(orientation: portrait)').matches;
};

exports.RESIZE_EVENT = 'resize';

exports.downloadPDF = function (content, fileName, options, tabletBreakpoint) {
  downloadjs_1.default(content, fileName, 'application/pdf');
  setTimeout(function () {
    var newBlob = new Blob([content], {
      type: 'application/pdf'
    });
    var data = window.URL.createObjectURL(newBlob);

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
    } else {
      if (options.openOnTab && exports.isDesktop(tabletBreakpoint)) {
        if (options.seeSameTab) {
          window.location.replace(data);
        } else window.open(data, '_blank');
      }
    }
  }, 100);
};

exports.decodeBase64 = function (base64) {
  var byteCharacters;

  try {
    byteCharacters = atob(base64);
  } catch (_a) {
    byteCharacters = null;
  }

  return byteCharacters;
};

exports.openBase64 = function (base64, contentType) {
  var byteCharacters = atob(base64);
  var byteNumbers = new Array(byteCharacters.length);

  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  var byteArray = new Uint8Array(byteNumbers);
  var blob = new Blob([byteArray], {
    type: contentType
  });
  var blobUrl = window.URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
};

exports.isBottom = function (ref, height) {
  var refBottom = ref.current && ref.current.getBoundingClientRect().bottom;
  return refBottom && (refBottom <= height || refBottom <= window.innerHeight);
};

var BROWSER_UTILS = {
  isFirefox: exports.isFirefox,
  isIE: exports.isIE,
  getURLParams: exports.getURLParams,
  retrieveWidth: exports.retrieveWidth,
  isMobile: exports.isMobile,
  isTablet: exports.isTablet,
  isDesktop: exports.isDesktop,
  downloadPDF: exports.downloadPDF,
  isDesktopHD: exports.isDesktopHD,
  isBigScreen: exports.isBigScreen,
  isLandscape: exports.isLandscape,
  isPortrait: exports.isPortrait,
  isBottom: exports.isBottom,
  RESIZE_EVENT: exports.RESIZE_EVENT,
  decodeBase64: exports.decodeBase64,
  openBase64: exports.openBase64
};
exports.default = BROWSER_UTILS;